import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { collections } from '@/mocks/home';

export default function Collections() {
  return (
    <section id="collections" className="border-y border-background-200/70 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="专题合集"
          title="按主题逛，比刷列表更过瘾"
          desc="我们替你把分散的直播与短视频整理成专题，喜欢一个方向就能一口气看完。"
          action={
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-100 px-4 py-2 text-xs font-medium text-accent-800 md:text-sm">
              <i className="ri-bookmark-3-line" />
              共 124 个专题合集
            </span>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {collections.map((item, index) => (
            <Reveal key={item.id} delay={(index % 3) * 80}>
              <article className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
                <div className="relative aspect-[3/2] w-full overflow-hidden">
                  <img
                    src={item.cover}
                    alt={`${item.title} 专题合集封面`}
                    title={`糖豆视频 ${item.title} 专题合集`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-medium text-foreground-800 backdrop-blur-sm">
                    合集
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs">
                    <span className="flex items-center gap-1.5 font-medium text-foreground-700">
                      <i className="ri-group-line text-secondary-600" />
                      {item.count}
                    </span>
                    <span className="flex items-center gap-1.5 font-medium text-primary-600">
                      <i className="ri-refresh-line" />
                      {item.fresh}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}